import React from 'react'
import PropTypes from 'prop-types'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'

import {
  Eye as EyeIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
} from 'react-feather'

import constants from 'constants/index'
import useStyles from './styles'

const PreviewModeToggle = ({ previewMode, onChange }) => {
  const { PREVIEW_MODES } = constants.cookies.banner

  const classes = useStyles()

  const handlePreviewModeChange = (event, selectedMode) => {
    if (selectedMode) onChange(selectedMode)
  }

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={previewMode}
      onChange={handlePreviewModeChange}
      className={classes.root}
    >
      <ToggleButton value={PREVIEW_MODES.BANNER} title="Visualizar só o banner">
        <EyeIcon size={18} />
      </ToggleButton>
      <ToggleButton value={PREVIEW_MODES.DESKTOP} title="Visualizar no desktop">
        <MonitorIcon size={18} />
      </ToggleButton>
      <ToggleButton value={PREVIEW_MODES.MOBILE} title="Visualizar no celular">
        <SmartphoneIcon size={18} />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

PreviewModeToggle.propTypes = {
  previewMode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default PreviewModeToggle
